<template>
    <div class="content-outer">
        <div class="content-top">
            <slot name="top" />
        </div>
        <div class="content-middle">
            <slot name="middle" />
        </div>
        <div class="content-bottom">
            <slot name="bottom" />
        </div>
    </div>
</template>

<style scoped>
.content-outer {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 0.05fr 1fr 0.05fr;
    height: 100%;
    gap: 0.625rem;
    padding-inline: 3%;
}

.content-top {
    display: flex;
    flex: 0;
    flex-direction: row;
    gap: 1.25rem;
    justify-content: flex-end;
    align-items: center;
}

.content-middle {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-around;
    gap: 2.5%;
}

.content-bottom {
    display: flex;
    flex: 0;
    flex-direction: row;
}
</style>
